module.exports = __webpack_public_path__ + "/build/web/images/matching-pillows-option-flange.62a1214f271c0971d958d16a4be6753f.png";


//////////////////
// WEBPACK FOOTER
// ./images/matching-pillows-option-flange.png
// module id = 169
// module chunks = 13